module.exports = "pegasus_template/assets/tech/medium/2.jpg";